import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from './RecordTable.module.css';
import backend from '../../../../../../api';

export default function MoreDropDown({ invoiceId, canPay, handleOpenEmailPopup }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const navigateTo = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropDown(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const payInvoice = async () => {
    try {
      const { data } = await backend.post(`/api/invoices/${invoiceId}/pay`);
      if (data?.ok && data.url) window.location.assign(data.url);
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    }
  };

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
        <div className={Classes.dropdownIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" height='15px' viewBox="0 0 128 512">
            <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
          </svg>
        </div>
      </div>

      <AnimatePresence>
        {dropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
            style={{ top: '13px', right: '30px' }}
          >
            <div className={Classes.dropDownBodyInner}>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px' }}
                onClick={() => { setDropDown(false); navigateTo(`/view-invoice/${invoiceId}`); }}
              >
                <h5>View Invoice</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px', opacity: canPay ? 1 : 0.5, pointerEvents: canPay ? 'auto' : 'none' }}
                onClick={() => { setDropDown(false); payInvoice(); }}
              >
                <h5>Pay Invoice</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div
                className={Classes.dropDownElem}
                style={{ padding: '5px 10px', color: 'red' }}
                onClick={() => { handleOpenEmailPopup(); setDropDown(false); }}
              >
                <h5>Share Invoice</h5>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <input type="hidden" aria-label="Without label" readOnly />
    </div>
  );
}
